import React, { PropsWithChildren } from 'react';
import Div from './Div';
import classNames from 'classnames';

type FixedWrapperProps = {
  position: 'bottom' | 'right';
  className?: string;
};

const POSITION_CLASS_MAP = {
  bottom: 'bottom-0 left-0 right-0',
  right: 'bottom-0 top-0 right-0',
};

FixedWrapper.defaultProps = {
  position: 'bottom',
};

export default function FixedWrapper({
  position,
  children,
  className,
}: PropsWithChildren<FixedWrapperProps>) {
  return (
    <Div className={classNames('fixed', POSITION_CLASS_MAP[position] ?? '', className)}>
      {children}
    </Div>
  );
}
